import React from "react";
import { Form, Select } from "antd";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const FormMultiSelect = (props) => {
  // -------------------------- VAR -----------------------------
  const name = props?.name || "Tên";
  const label = props?.label || "Tiêu đề";
  const placeholder = props?.placeholder || "Nhập Tiêu Đề";
  const options = props?.options || [];
  const disabled = props?.disabled || false;
  const initialValue = options?.length > 0 ? options[0].value : "";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Form.Item name={name} label={label} initialValue={[initialValue]}>
      <Select
        mode="multiple"
        placeholder={placeholder}
        options={options}
        disabled={disabled}
      />
    </Form.Item>
  );
};
export default FormMultiSelect;
